import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import PATHS from 'lib/navigation/paths';
import {
  RiEarthLine,
  RiGuideLine,
  RiTreasureMapLine,
  RiMotorbikeFill,
  RiPriceTag3Line,
  RiCalendar2Line,
} from 'react-icons/ri';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import {
  DROPDOWN_REF,
  NAVBAR_REF,
} from 'views/rebranded-module/common/utils/constants';
import EagleRide from 'views/rebranded-module/common/icons/EagleRide';

const useNavigationItems = (simple) => {
  const { t } = useTranslation();
  const showMembership = useSelector(
    (state) => state.globalData.showMembership,
  );
  const appNavigator = useAppNavigator();
  const navigationItems = useMemo(() => {
    const navBarUtm = {
      ref: simple ? DROPDOWN_REF : NAVBAR_REF,
      sourcePage: appNavigator.pathname,
    };
    const items = [
      {
        label: t('common_layout_v2:destinations'),
        path: PATHS.locations(navBarUtm),
        icon: <RiEarthLine />,
        testId: 'nav-locations',
      },
      {
        label: t('common_layout_v2:rentals_link'),
        path: PATHS.motorcycleRental(navBarUtm),
        icon: <RiMotorbikeFill />,
        testId: 'nav-rentals',
      },
      {
        label: t('common_layout_v2:tours'),
        path: PATHS.motorcycleTours.index(navBarUtm),
        icon: <RiGuideLine />,
        testId: 'nav-packages_and_tours',
      },
      {
        label: t('common_layout_v2:off_road'),
        path: PATHS.guidedOffroadTour.index(navBarUtm),
        icon: <RiTreasureMapLine />,
        testId: 'nav-off_road',
      },
      {
        label: t('common_layout_v2:exclusive_Offers'),
        path: PATHS.motorcycleDeals.index(navBarUtm),
        icon: <RiPriceTag3Line />,
        testId: 'nav-exclusive_offers',
      },
      {
        label: t('common_layout_v2:events'),
        path: PATHS.motorcycleEvents.index(navBarUtm),
        icon: <RiCalendar2Line />,
        testId: 'nav-events',
      },
    ];

    if (showMembership) {
      items.splice(4, 0, {
        label: t('common_layout_v2:navigation.join_club'),
        path: PATHS.motorcycleClub.index(navBarUtm),
        icon: <EagleRide />,
        testId: 'nav-join_club',
      });
    }

    return items;
  }, [simple, showMembership]);

  return navigationItems;
};

export default useNavigationItems;
